import React, { useState, useCallback } from "react";
import { Table } from "../../../../components/ui/Table";
import PropTypes from "prop-types";
import { Tooltip } from "../../../ui/Tooltip";
import _ModalDeleteRCSAgent from "../../../modal/administration/customer/_ModalDeleteRCSAgent";
import _ModalDetailRCSAgent from "../../../modal/administration/customer/_ModalDetailRCSAgent";
import _ModalDevicesRcsAgent from "../../../modal/administration/customer/_ModalDevicesRCSAgent";
import { useMutation } from "@tanstack/react-query";
import { ErrorMessage, SuccessMessage } from "../../../../utils/toastify";
import { httpClient } from "../../../../utils/HttpClient";
import { ApiEndpoint } from "../../../../utils/ApiEndpoint";
import { useAuth } from "../../../../Context/AuthContext";
import { useNavigate } from "react-router-dom";
const TableAgentRCS = ({ data = [], isLoading = false, refetchAgentsRcs }) => {
  const auth = useAuth();
  const { token } = auth.getSessionData();
  const navigate = useNavigate();

  const agentActions = useCallback(
    (item) => {
      if ([9].includes(item.id_partnerrcs) && !item.b_active) {
        return (
          <Tooltip message="Dispositivos Test" placement="top">
            <button
              className="bg-gray-100 hover:bg-gray-200 hover:text-gray-400 text-gray-700 border-none rounded-lg flex items-center gap-2 px-2 py-1"
              onClick={() => {
                navigate(
                  "administration/Customers/details/" +
                    item.uid_partner +
                    "/agents/devices/" +
                    item.vc_agentid,
                );
              }}
            >
              <span className="material-symbols-outlined">mobile_chat</span>
            </button>
          </Tooltip>
        );
      }

      return (
        <Tooltip message="Enviar mensaje prueba" placement="top">
          <button
            className="bg-gray-100 hover:bg-gray-200 hover:text-gray-400 text-gray-700 border-none rounded-lg flex items-center gap-2 px-2 py-1"
            onClick={() => {
              setDevice({
                data: item,
                visible: true,
              });
            }}
          >
            <span className="material-symbols-outlined">business_messages</span>
          </button>
        </Tooltip>
      );
    },
    [navigate],
  );

  const [remove, setRemove] = useState({
    visible: false,
    data: null,
  });
  const [visible, setVisible] = useState({
    visible: false,
    data: null,
  });
  const [device, setDevice] = useState({
    visible: false,
    data: null,
  });
  const columns = [
    {
      accessor: "vc_partner",
      Header: "Partner",
    },
    {
      accessor: "vc_name",
      Header: "Nombre",
    },
    {
      accessor: "vc_agentid",
      Header: "Agente",
    },
    {
      accessor: "vc_provider",
      Header: "Proveedor",
    },
    {
      accessor: "vc_carrier",
      Header: "Operadora",
      headerProps: {
        className: "text-center w-[400px]",
      },
      Cell: (rowData) => {
        let value = rowData.row.original.vc_carrier;
        return <div className="text-center">{value}</div>;
      },
    },
    {
      accessor: "none",
      Header: "Acciones",
      disableSortBy: true,
      headerProps: {
        className: "text-center w-[100px]",
      },
      cellProps: {
        className: "text-center",
      },
      Cell: (rowData) => {
        let item = rowData.row.original;

        return (
          <div className="flex justify-end gap-2">
            <Tooltip message="Eliminar" placement="top">
              <button
                className="bg-gray-100 hover:bg-gray-200 hover:text-gray-400 text-gray-700 border-none rounded-lg flex items-center gap-2 px-2 py-1"
                onClick={() =>
                  setRemove({
                    data: {
                      id: item.id_partnerrcs,
                    },
                    visible: true,
                  })
                }
              >
                <span className="material-symbols-outlined">delete</span>
              </button>
            </Tooltip>
            <Tooltip message="Detalles" placement="top">
              <button
                className="bg-gray-100 hover:bg-gray-200 hover:text-gray-400 text-gray-700 border-none rounded-lg flex items-center gap-2 px-2 py-1"
                onClick={() => {
                  setVisible({
                    data: item,
                    visible: true,
                  });
                }}
              >
                <span className="material-symbols-outlined">dock_to_left</span>
              </button>
            </Tooltip>

            {agentActions(item)}
          </div>
        );
      },
    },
  ];

  const { mutate: onDelete, isPending: isLoadingDelete } = useMutation({
    mutationKey: ["deleteRCSAgent", remove?.data?.id],
    mutationFn: async () => {
      const response = await httpClient(
        "DELETE",
        `${ApiEndpoint}administration/unasignrcsagent/${remove?.data?.id}`,
        {},
        token,
      );
      return response.data;
    },
    onSuccess: () => {
      setRemove({ visible: false, data: null });
      refetchAgentsRcs();
      SuccessMessage("Agente Eliminado");
    },
    onError: () => {
      ErrorMessage("Error al eliminar agente");
    },
  });
  return (
    <div>
      <Table
        columns={columns}
        data={data}
        loading={isLoading}
        config={{
          search: false,
          pageSize: 10,
          perPage: 10,
          pagination: true,
          rowInfo: true,
          rowsPerPageSelection: true,
          navButtons: false,
          footer: true,
        }}
      />
      <_ModalDeleteRCSAgent
        title="Eliminar Agente"
        description="¿Desea eliminar el agente?"
        onDelete={onDelete}
        visible={remove.visible}
        onClose={() => setRemove({ visible: false, data: null })}
        isLoading={isLoadingDelete}
      />
      <_ModalDetailRCSAgent
        title="Detalles Agente"
        visible={visible.visible}
        data={visible.data}
        onClose={() => setVisible({ visible: false, data: null })}
      />
      <_ModalDevicesRcsAgent
        title="Dispositivos Agente"
        visible={device.visible}
        data={device.data}
        onClose={() => setDevice({ visible: false, data: null })}
      />

      <_ModalDevicesRcsAgent
        title="Mensaje de prueba"
        visible={device.visible}
        data={device.data}
        onClose={() => setDevice({ visible: false, data: null })}
        isTestMessage
      />
    </div>
  );
};

TableAgentRCS.propTypes = {
  data: PropTypes.array,
  isLoading: PropTypes.bool,
  refetchAgentsRcs: PropTypes.func,
};

export default TableAgentRCS;
